// src/api/apiClient.js
import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api-loyola-enotes.trinodepointers.com/api",
  headers: { "Content-Type": "application/json" },
});

// ✅ Inject access token into every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ✅ Handle expired token automatically with refresh token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL || "https://api-loyola-enotes.trinodepointers.com/api"}/refresh`,
          { refresh_token: refreshToken }
        );

        const { access_token } = response.data;

        // ✅ Save new token
        localStorage.setItem("accessToken", access_token);

        // ✅ Update retry request header
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        apiClient.defaults.headers.Authorization = `Bearer ${access_token}`;

        return apiClient(originalRequest);
      } catch (err) {
        console.error("Token refresh failed:", err);
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;

